import "./tailwind.css";
import { createRoot } from "react-dom/client";
import App from "./ui/App";

// Ensure Office is ready before rendering
Office.onReady(() => {
  const rootEl = document.getElementById("root");
  if (!rootEl) return;
  const root = createRoot(rootEl);
  root.render(<App />);
});
